
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("kFWau", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0d4c1fa6b7c3106$var$_react = $f0d4c1fa6b7c3106$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f0d4c1fa6b7c3106$var$_iconNew = $f0d4c1fa6b7c3106$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f0d4c1fa6b7c3106$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0d4c1fa6b7c3106$var$AddIcon = (props)=>/*#__PURE__*/ $f0d4c1fa6b7c3106$var$_react.default.createElement($f0d4c1fa6b7c3106$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$f0d4c1fa6b7c3106$var$AddIcon.displayName = 'AddIcon';
var $f0d4c1fa6b7c3106$var$_default = module.exports.default = $f0d4c1fa6b7c3106$var$AddIcon;

});


//# sourceMappingURL=rovo-skill-icon-add.6bd0270c.js.map
